import { useTranslation } from "react-i18next";
import { useAnalytics } from "@commons-monorepo/index";
import { PaginationProps } from "./pagination.types";
import { useAppLocation } from "@commons-monorepo/index";
import { useCallback, useMemo } from "react";
import { PAGINATION_EVENTS } from "./pagination.events";
import { useOutletContext } from "@remix-run/react";

export const usePagination = ({ page }: PaginationProps) => {
  const { storeMetadata } = useOutletContext<any>();
  const { t } = useTranslation();
  const [logEvent] = useAnalytics({ storeMetadata });
  const { pathname, search } = useAppLocation();

  const launchChangePageEvent = (payload: string) => {
    logEvent(PAGINATION_EVENTS.SELECT_CATALOG_PAGE, { payload });
  };

  const querySearch = useMemo(() => new URLSearchParams(search), [search]);

  const createUrlWithPagination = useCallback(
    (itemPage: number) => {
      const queryParams = new URLSearchParams(querySearch);
      queryParams.set("page", String(itemPage));
      return `${pathname}?${queryParams.toString()}`;
    },
    [querySearch, pathname],
  );

  const prevLink = useMemo(
    () => createUrlWithPagination(page - 1),
    [page, createUrlWithPagination],
  );

  const nextLink = useMemo(
    () => createUrlWithPagination(page + 1),
    [page, createUrlWithPagination],
  );

  const isActive = useCallback((itemPage: number) => itemPage === page, [page]);

  return {
    t,
    prevLink,
    nextLink,
    logEvent,
    launchChangePageEvent,
    isActive,
    createUrlWithPagination,
  };
};
